module.exports = __webpack_public_path__ + "img/red-sox.032fbf71.svg";